import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 border-t border-white/5 bg-[#141414]" data-id="element-60">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-61">
          <p className="text-gray-600 text-sm" data-id="element-62">
            © {new Date().getFullYear()} IA Simplificada. Todos los derechos
            reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-63">
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-gray-500 hover:text-amber-500 transition-colors" data-id="element-64">
              Política de Privacidad
            </button>
            <span className="text-gray-700" data-id="element-65">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-sm text-gray-500 hover:text-amber-500 transition-colors" data-id="element-66">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-67">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-68">
            <motion.div initial={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} transition={{
          duration: 0.3
        }} onClick={e => e.stopPropagation()} className="bg-[#1A1A1A] border border-white/10 rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl" data-id="element-69">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-white/5" data-id="element-70">
                <h2 className="text-xl font-bold text-white" data-id="element-71">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="text-gray-500 hover:text-white transition-colors p-1 rounded-lg hover:bg-white/5" data-id="element-72">
                  <X className="w-5 h-5" data-id="element-73" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-gray-400 leading-relaxed space-y-6" data-id="element-74">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-75" /> : <TermsContent data-id="element-76" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-sm text-gray-500" data-id="element-77">Última actualización: Marzo 2026</p>

      <section className="space-y-3" data-id="element-78">
        <h3 className="text-lg font-semibold text-white" data-id="element-79">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-80">
          Recopilamos información personal que nos proporcionas directamente al
          realizar una compra, como tu nombre, dirección de correo electrónico y
          datos de pago. También podemos recopilar información de uso de forma
          automática, como tu dirección IP, tipo de navegador y páginas
          visitadas.
        </p>
      </section>

      <section className="space-y-3" data-id="element-81">
        <h3 className="text-lg font-semibold text-white" data-id="element-82">
          2. Uso de la Información
        </h3>
        <p data-id="element-83">Utilizamos tu información para:</p>
        <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-84">
          <li data-id="element-85">Procesar y entregar tu compra del eBook.</li>
          <li data-id="element-86">Enviarte actualizaciones relacionadas con el producto.</li>
          <li data-id="element-87">Mejorar nuestros servicios y experiencia de usuario.</li>
          <li data-id="element-88">Cumplir con obligaciones legales.</li>
        </ul>
      </section>

      <section className="space-y-3" data-id="element-89">
        <h3 className="text-lg font-semibold text-white" data-id="element-90">
          3. Protección de Datos
        </h3>
        <p data-id="element-91">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado, pérdida
          o alteración. Tus datos de pago son procesados de forma segura a
          través de proveedores de pago certificados.
        </p>
      </section>

      <section className="space-y-3" data-id="element-92">
        <h3 className="text-lg font-semibold text-white" data-id="element-93">
          4. Compartir Información
        </h3>
        <p data-id="element-94">
          No vendemos ni compartimos tu información personal con terceros,
          excepto cuando sea necesario para procesar tu compra o cuando la ley
          lo requiera.
        </p>
      </section>

      <section className="space-y-3" data-id="element-95">
        <h3 className="text-lg font-semibold text-white" data-id="element-96">5. Tus Derechos</h3>
        <p data-id="element-97">
          Tienes derecho a acceder, corregir o eliminar tu información personal.
          Para ejercer estos derechos, contáctanos a través de nuestro correo
          electrónico de soporte.
        </p>
      </section>

      <section className="space-y-3" data-id="element-98">
        <h3 className="text-lg font-semibold text-white" data-id="element-99">6. Contacto</h3>
        <p data-id="element-100">
          Si tienes preguntas sobre esta política de privacidad, puedes
          contactarnos en cualquier momento a través de nuestros canales de
          soporte.
        </p>
      </section>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-sm text-gray-500" data-id="element-101">Última actualización: Marzo 2026</p>

      <section className="space-y-3" data-id="element-102">
        <h3 className="text-lg font-semibold text-white" data-id="element-103">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-104">
          Al comprar y descargar el eBook "IA para Dueños de Negocios", aceptas
          estos términos y condiciones en su totalidad. Si no estás de acuerdo
          con alguno de estos términos, no realices la compra.
        </p>
      </section>

      <section className="space-y-3" data-id="element-105">
        <h3 className="text-lg font-semibold text-white" data-id="element-106">
          2. Producto Digital
        </h3>
        <p data-id="element-107">
          El eBook es un producto digital que se entrega en formato electrónico
          inmediatamente después de la compra. Debido a la naturaleza digital
          del producto, no se aceptan devoluciones una vez completada la
          descarga.
        </p>
      </section>

      <section className="space-y-3" data-id="element-108">
        <h3 className="text-lg font-semibold text-white" data-id="element-109">3. Licencia de Uso</h3>
        <p data-id="element-110">
          Al comprar el eBook, recibes una licencia personal e intransferible
          para su uso. Queda prohibido:
        </p>
        <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-111">
          <li data-id="element-112">Reproducir o distribuir el contenido sin autorización.</li>
          <li data-id="element-113">Compartir el archivo con terceros.</li>
          <li data-id="element-114">Utilizar el contenido con fines comerciales de reventa.</li>
          <li data-id="element-115">Modificar o crear obras derivadas del contenido.</li>
        </ul>
      </section>

      <section className="space-y-3" data-id="element-116">
        <h3 className="text-lg font-semibold text-white" data-id="element-117">
          4. Propiedad Intelectual
        </h3>
        <p data-id="element-118">
          Todo el contenido del eBook, incluyendo texto, gráficos, plantillas y
          checklists, está protegido por derechos de autor y es propiedad
          exclusiva de IA Simplificada.
        </p>
      </section>

      <section className="space-y-3" data-id="element-119">
        <h3 className="text-lg font-semibold text-white" data-id="element-120">
          5. Limitación de Responsabilidad
        </h3>
        <p data-id="element-121">
          Los resultados pueden variar según la implementación individual. No
          garantizamos resultados específicos de negocio. El eBook proporciona
          información educativa y herramientas, pero el éxito depende de la
          aplicación por parte del usuario.
        </p>
      </section>

      <section className="space-y-3" data-id="element-122">
        <h3 className="text-lg font-semibold text-white" data-id="element-123">6. Modificaciones</h3>
        <p data-id="element-124">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor desde su publicación en
          esta página.
        </p>
      </section>
    </>;
}